export default __webpack_public_path__ + "static/media/fernando.e26bb297.png";